<template>
	<div class="container">
		<Header />
		<div class="content">
			<div class="table">
				<div class="title">功能报表</div>
				<div class="table_content">
					<el-table :data="tableData" border class="report_table">
						<el-table-column prop="id" label="序号" width="80"></el-table-column>
						<el-table-column prop="unitName" label="合作单位"></el-table-column>
						<el-table-column prop="staffName" label="操作员工" width="140"></el-table-column>
						<el-table-column prop="accessCount" label="资料访问次数" width="160" align="center"></el-table-column>
						<el-table-column prop="accessDate" label="统计日期" width="180"></el-table-column>
						<el-table-column prop="remark" label="备注"></el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>

<script>
	import Header from "../../components/common/Header";
	import Footer from "../../components/common/Footer";
	import api from "../../axios/interface";
	export default {
		name: "SysReport",
		data() {
			return {
				tableData: []
			};
		},
		components: {
			Header,
			Footer
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				// this.$axios.get(api.SysReportList, {}, { hideMessage: true }).then(res => {
				//   this.tableData = res.result.data;
				// })
				this.tableData = [
					{
						id: 1,
						unitName: "知联合作点",
						staffName: "王超杰",
						accessCount: 134,
						accessDate: "2021-05-11",
						remark: "日常资料查阅"
					},
					{
						id: 2,
						unitName: "春江合作点",
						staffName: "王超杰",
						accessCount: 107,
						accessDate: "2021-08-06",
						remark: "档案核对访问"
					},
					{
						id: 3,
						unitName: "桂花路合作点",
						staffName: "王超杰",
						accessCount: 86,
						accessDate: "2023-10-12",
						remark: ""
					},
					{
						id: 4,
						unitName: "新登宿邦合作点",
						staffName: "李玲",
						accessCount: 142,
						accessDate: "2024-03-01",
						remark: "业务资料调取"
					},
					{
						id: 5,
						unitName: "松溪合作点",
						staffName: "李玲",
						accessCount: 93,
						accessDate: "2025-01-06",
						remark: ""
					},
					{
						id: 6,
						unitName: "富阳十小合作点",
						staffName: "李玲",
						accessCount: 115,
						accessDate: "2026-04-09",
						remark: "月度资料汇总查阅"
					}
				];
			}
		}
	};
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		height: 100vh;
		overflow: hidden;
	}
	.content {
		width: 1056px;
		margin: 90px 50px 0 50px;
		height: auto;
		text-align: center;
		padding-bottom: 30px;
		border-radius: 10px;
		background: #fff;
		display: flex;
		flex-direction: column;
	}
	.content .table {
		width: 960px;
		height: auto;
		margin: 0 48px;
		.title {
			height: 45px;
			line-height: 45px;
			text-align: center;
			font-size: 32px;
			color: #4d4d4d;
			margin-top: 70px;
			margin-bottom: 30px;
		}
		.table_content {
			border-radius: 5px;
		}
	}
	.report_table {
		thead {
			tr > th {
				.cell {
					color: #333333;
					font-weight: 500;
				}
			}
		}
		td,
		th.is-leaf {
			border-bottom: 1px solid #eeeeee;
		}
	}
</style>
